export const getPageRights = (userPages = [], pageId) => {
    if (!pageId) return { view: false, add: false, edit: false, delete: false };
  
    const access = userPages.find((p) => p.pageId === pageId);
  
    return {
      view: access?.view ?? false,
      add: access?.add ?? false,
      edit: access?.edit ?? false,
      delete: access?.delete ?? false,
    };
  };
  